import React from 'react';
import DialogComponent from '../../../component/dialog/dialog.component';
import AuthorizationManager from '../authorization-manager/authorization-manager';
import { Box } from '@mui/system';
import i18n from '../../../i18n';

export default function RestaurantAuthDialog(props: { open: boolean, onCancel: () => void, restaurantStringId: string }) {


    React.useEffect(() => {
        if (props.open === true) {

        }
    }, [props.open])

    return (
        <DialogComponent
            open={props.open}
            onClose={() => {
                props.onCancel?.()
            }}
            fullWidth
            heightSize={'large'}
            defaultHeaderProps={
                {
                    title: i18n.t('warrant_page_text_authorization_scheme')
                }
            }
        >
            <Box style={{ padding: '8px 0' }}>
                <AuthorizationManager comType={'RESTAURANT'} restaurantStringId={props.restaurantStringId} />
            </Box>
        </DialogComponent>
    )
}